// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"36b0e7ae","719":"55d003e2","787":"1a8eeb48"}[chunkId] + ".chunk.js";
};